// removed by extract-text-webpack-plugin
module.exports = {"base":"BuildingView_base--2P3-c","view":"BuildingView_view--3RX5N","back":"BuildingView_back--1pf40","carousel":"BuildingView_carousel--2VG_R"};


//////////////////
// WEBPACK FOOTER
// ./containers/BuildingView/BuildingView.scss
// module id = 2152
// module chunks = 11